import React from "react";
import { StyleSheet, View } from "react-native";

import Icons from "../../common/icons/index";
import CollapseDetailsIcon from "../../common/icons/CollapseDetailsIcon";
import IntegrationIcons from "../../common/icons/integrations/index";
import appStyles from "../../../appStyles";

export default function ActivitySource(props) {
  const {
    source,
    width = 16,
    height = 16,
    onPress,
    isCollapsed = false,
    showCollapseIcon = false,
    showIconContainer = false,
  } = props;

  if (!source?.name) return null;

  const SOURCE_ICON =
    source.name === "calendar_google" || source.name === "cal"
      ? Icons.GCalendarIcon
      : source.name === "calendar_native"
      ? Icons.Calendar
      : source.name === "chrome"
      ? Icons.ChromeIcon
      : source.name === "health"
      ? Icons.AppleHealthIcon
      : source.name === "windows"
      ? IntegrationIcons.WindowsIcon
      : source.name === "slack"
      ? IntegrationIcons.SlackIcon
      : source.name === "location"
      ? IntegrationIcons.LocationIcon
      : source.name === "macos"
      ? IntegrationIcons.MacIcon
      : source.name === "outlook"
      ? IntegrationIcons.OutlookIcon
      : null;

  return (
    <View
      style={[styles.flex, showIconContainer ? appStyles.iconContainer : {}]}
    >
      {showCollapseIcon ? (
        <CollapseDetailsIcon
          isCollapsed={isCollapsed}
          onPress={onPress ? () => onPress(source.id) : null}
          style={styles.collapseIcon}
        />
      ) : null}

      {source.name === "routine" ? (
        <Icons.RoutinesIcon
          width={width}
          height={height}
          style={{ width, height }}
        />
      ) : null}
      {source.name === "autoreview" ||
      source.name === "prediction" ||
      source.name === "atus" ? (
        <Icons.ManaIcon
          width={width}
          height={height}
          style={{ width, height }}
        />
      ) : null}

      {SOURCE_ICON ? (
        <SOURCE_ICON
          {...props}
          width={width}
          height={height}
          style={{ width, height }}
          onPress={onPress ? () => onPress(source.id, true) : null}
        />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  flex: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    position: "relative",
  },
  icon: {
    width: 16,
    height: 16,
  },
  collapseIcon: {
    width: 12,
    height: 12,
    position: "absolute",
    right: -4,
    bottom: -4,
    zIndex: 10,
  },
});
